import { Button, InlineError, Input } from 'avo-ui'
import icAddSquare from 'assets/images/ic-add-square.svg'
import TabToggleList from 'components/commons/tab-toogle-list'
import TabToggle from 'components/commons/tab-toogle'
import Select from 'components/commons/select'

export const ProductItem = ({
    sectionRef,
    items,
    setItems,
    onChangeItem,
    onAddNewItem,
    onFilterOptions,
    onSearchProduct,
    errorForm,
}) => {
    const getError = (key, index) => {
        const findError = errorForm?.products_detail?.find((i) => i?.index === index && i?.key === key)
        return findError?.message
    }

    return (
        <div ref={sectionRef}>
            <TabToggle
                title={'Product Item'}
                content={
                    <div className={'flex flex-col space-y-6'}>
                        {items?.map((item, index) => (
                            <TabToggleList
                                key={`product-${index}`}
                                index={index}
                                title={`Product-Item-${index + 1}`}
                                content={
                                    <div className={'w-4/6 space-y-5'}>
                                        <div className={'flex flex-col space-y-3'}>
                                            <div className={'font-semibold text-blue-90 required'}>Pilih Product</div>
                                            <Select
                                                name={'product_id'}
                                                className={'flex-1'}
                                                optionsClassName={'max-h-40'}
                                                placeholder={'Pilih product'}
                                                options={onFilterOptions(index)}
                                                value={item?.product_id}
                                                searchable
                                                onChange={(item) => onChangeItem({ ...item, index })}
                                                onSearch={(value) => onSearchProduct(value)}
                                            />
                                            <InlineError className='mt-2' message={getError('product_id', index)} />
                                        </div>
                                        <div className={'flex items-start justify-between'}>
                                            <div className={'flex flex-col space-y-3'}>
                                                <div className={'font-semibold text-blue-90 required'}>
                                                    Harga Diskon
                                                </div>
                                                <Input
                                                    type={'currency'}
                                                    className={'flex-1'}
                                                    name={'price'}
                                                    addonBefore={'Rp'}
                                                    placeholder={'Masukkan harga diskon'}
                                                    value={item?.price}
                                                    onChange={(item) => onChangeItem({ ...item, index })}
                                                />
                                                <InlineError className='mt-2' message={getError('price', index)} />
                                            </div>
                                            <div className={'flex flex-col space-y-3'}>
                                                <div className={'font-semibold text-blue-90 required'}>
                                                    Quantity Product
                                                </div>
                                                <Input
                                                    type={'number'}
                                                    className={'flex-1'}
                                                    name={'stock_quantity'}
                                                    placeholder={'Masukkan stok produk'}
                                                    value={item?.stock_quantity}
                                                    onChange={(item) => onChangeItem({ ...item, index })}
                                                />
                                                <InlineError
                                                    className='mt-2'
                                                    message={getError('stock_quantity', index)}
                                                />
                                            </div>
                                            <div className={'flex flex-col space-y-3'}>
                                                <div className={'font-semibold text-blue-90'}>Limit Pembelian</div>
                                                <Input
                                                    type={'number'}
                                                    className={'flex-1'}
                                                    name={'limit_purchase'}
                                                    placeholder={'Masukkan limit pembelian'}
                                                    value={item?.limit_purchase}
                                                    onChange={(item) => onChangeItem({ ...item, index })}
                                                />
                                                <InlineError
                                                    className='mt-2'
                                                    message={getError('limit_purchase', index)}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                }
                                items={items}
                                setItems={setItems}
                                isDisableDelete={items?.length === 1}
                                isSorting
                            />
                        ))}
                        <InlineError className='mt-2' message={errorForm?.products} />
                        <Button
                            className={'w-fit'}
                            type={'outline'}
                            icon={icAddSquare}
                            title={'Add New Item'}
                            onClick={onAddNewItem}
                        />
                    </div>
                }
            />
        </div>
    )
}
